import * as logger from '../../logging/logger';
import { makeRequest } from '../makeRequest'

export async function downloadAndOpenFile(method: 'GET' | 'POST', path: string, type: string, data?: any) {
    try {
        const response = await makeRequest({ method, path, data, responseType: 'buffer' });
        if (response.status === 200) {
            const blob = await response.blob();
            const file = new Blob([blob], { type: type });
            const fileUrl = URL.createObjectURL(file);
            window.open(fileUrl, 'FileWnd', 'fullscreen=yes');
            
            // 20ms * 1000 = 20s * 60 = 20min == 1,200,000
            setTimeout(function() { URL.revokeObjectURL(fileUrl); }, 1200000);
        } else {
            logger.log('Debug', `downloadAndOpenFile: Error: ${response.statusText}`);
            throw new Error(response.statusText);
        }
    } catch (error) {
        logger.log('Debug', `downloadAndOpenFile: Error: ${error.message}`);
        throw error;
    }
}
